import { MaritalStatusValue, EducationalAttainmentValue } from 'app/rm/erp/common/person/model/person-values';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HisBackendService } from 'hisng';
import { formatDate } from '@angular/common';

@Injectable()
export class ErpPersonService {
    private currentDate: string = formatDate( Date.now(), 'yyyy-MM-dd', 'de-DE' );

    constructor( private readonly backendService: HisBackendService ) { }

    getMaritalStatusValues(): Observable<MaritalStatusValue[]> {
        return this.backendService.getData( `api/v1/rm/erp/person/value/maritalstatus?filter_validon=${this.currentDate}` );
    }

    getEducationalAttainmentValues(): Observable<EducationalAttainmentValue[]> {
        return this.backendService.getData( `api/v1/rm/erp/person/value/educationalattainment?filter_validon=${this.currentDate}` );
    }
}
